import cn from "classnames";
import { useTableContext } from "./TableContext";

interface Props {
  children: React.ReactNode;
  variant?: "default" | "plain";
  className?: string;
}

export function Header({ children, variant = "default", className }: Props) {
  const { rounded } = useTableContext();
  return (
    <thead
      className={cn(
        variant === "default" &&
          cn(
            "surface-tertiary-fill border-b surface-container-stroke",
            rounded &&
              "[&>tr:first-child>th:first-child]:rounded-tl-[17px] [&>tr:first-child>th:last-child]:rounded-tr-[17px]",
          ),
        variant === "plain" && "bg-transparent border-b surface-container-stroke",
        className,
      )}>
      {children}
    </thead>
  );
}
